export class ActivePage {
  type: string;
  name?: string;
  id?: number | string;
}



// WEBPACK FOOTER //
// ./src/models/event-tracker.ts